import { Box, Stack, Typography } from '@mui/material'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import storeComplexPassword from 'GlobalStores/StoreComplexPassword'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

const PasswordStrengthBar = observer(({ password, isShowDescription = true }) => {

  const [complexPassword, setComplexPassword] = useState({
    strengthPoint: false,
    background: '#F2F4F7',
    text: 'password_strength',
  })

  const totalBars = 5

  const checkPasswordStrength = (password) => {
    let strength = 0

    const criteria = [
      {
        regex: /[a-z]/,
        error: 'error_password_least_one_lowercase',
      },
      {
        regex: /[A-Z]/,
        error: 'error_password_least_one_uppercase',
      },
      {
        regex: /[0-9]/,
        error: 'error_password_least_one_number',
      },
      {
        regex: /[!@#$%^&*(),.?":{}|<>+-/_=]/,
        error: 'error_password_least_one_special',
      },
    ]

    criteria.forEach(({ regex, error }) => {
      if (regex.test(password)) {
        strength++
      }
    })

    if (password.length >= 8) {
      strength++
    }

    const strengthLevels = [
      { background: '#F2F4F7', text: 'password_strength' },
      { background: '#F44336', text: 'very_weak' },
      { background: '#FFF422', text: 'weak' },
      { background: '#4CAF50', text: 'good' },
      { background: '#4CAF50', text: 'strong' },
      { background: '#4CAF50', text: 'strong' },
    ];

    const level = Math.min(strength, strengthLevels.length - 1)

    setComplexPassword({
      strengthPoint: strength,
      background: strengthLevels[level].background,
      text: strengthLevels[level].text,
    })
  }

  useEffect(() => {
    checkPasswordStrength(password)
    storeComplexPassword.checkPasswordStrength(password)
  }, [password])

  return (
    <Stack sx={{ width: '100%', marginTop: '8px' }}>
      <Stack sx={{ width: '100%', flexDirection: 'row', gap: '5px' }}>
        {Array.from({ length: totalBars }).map((_, index) => (
          <Stack
            key={index}
            sx={{
              width: '100%',
              height: '6px',
              background: index < complexPassword.strengthPoint ? complexPassword.background : '#F2F4F7',
              borderRadius: '50px',
              transition: 'background 0.3s ease',
            }}
          />
        ))}
      </Stack>

      <Stack sx={{ width: '100%', marginTop: '4px' }}>
        <Typography sx={{ fontSize: '10px', fontWeight: 400, color: '#696969', textAlign: 'right' }}>
          <T>{complexPassword.text}</T>
        </Typography>
      </Stack>

      {isShowDescription && (
        <Box sx={{
          marginTop: '20px',
          backgroundColor: '#E9F5FA',
          padding: '16px 24px',
          borderRadius: '8px',
        }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#0B3B61', marginBottom: '12px' }}>
            <T>your_password_must_be_contain</T>
          </Typography>
          {storeComplexPassword.DESCRIPTION_KEYS.map((item, index) => (
            <Stack key={index} sx={{ display: 'flex', flexDirection: 'row', gap: '5px', paddingLeft: '8px' }}>
              • <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#0B3B61', paddingLeft: '5px' }}> <T>{item}</T> </Typography>
            </Stack>
          ))}
        </Box>
      )}

    </Stack>
  )
})

export default PasswordStrengthBar